module.exports = __webpack_public_path__ + "socicon.944f06f5f65ef84a3a36.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/socicon/socicon.woff
// module id = ../../../../../src/assets/vendors/base/fonts/socicon/socicon.woff
// module chunks = styles